'use client';
import { Button } from '@ethsign/ui';
import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useSearchParams } from '@/hooks';
import { getContractByApiKey } from '@/services/sign-sdk';
import { downloadContractFile } from '@/utils';

const Page = () => {
  const { id = '' } = useParams();
  const { apiKey, password } = useSearchParams();
  const getData = async () => {
    let success = true;
    let errorMessage = '';
    try {
      const [contractData]: any = await Promise.all([getContractByApiKey(id, apiKey)]);
      const { recipients, fileContent, contractType } = contractData;
      const res = await downloadContractFile({
        recipients,
        contractType,
        fileContent,
        password,
        data: contractData
      });
      success == res;
    } catch (error: any) {
      errorMessage = error.message;
      success = false;
    }
    window.top?.postMessage(
      { from: 'ethsign', type: 'download', status: success ? 'success' : 'error', message: errorMessage },
      '*'
    );
    window.close();
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Button onClick={getData}>download</Button>
    </>
  );
};

export default Page;
